const ca = {
  helmet_index_description : 'Descobreix les arees de picnic que hi han al teu voltant',
  home: 'Àrees',
  ajustes: 'Afegeix àrees',
  home_cerca: 'Prop de mi',
  menu_listado: 'Llistat',
  menu_mapa: 'Mapa',
  detalles_aseos: 'Lavabos',
  detalles_aseos_descripcion: 'Si n\'hi han lavabos al àrea',
  detalles_banyo: 'Àrea de Bany',
  detalles_banyo_descripcion: 'Llac, platja, piscina, ...',
  detalles_zona_infantil: 'Zona infantil',
  detalles_zona_infantil_descripcion: 'Parc, groxadors, tobogans, ...',
  detalles_mesas: 'Taules',
  detalles_mesas_descripcion: 'Si n\'hi han taules al àrea',
  detalles_alimentacion: 'Menjar',
  detalles_alimentacion_descripcion: 'Bar, restaurant, tenda, ...',
  add_zonas_title: 'Vols afegir mes àrees?',
  add_zonas_1: 'Fes click ',
  add_zonas_2: 'aqui',
  add_zonas_3: 'y ompli el formulari',
  add_zonas_4: 'Gràcies. La resta d\'usuaris gaudiran de la teva aportació.',
  add_zona: 'Afegir àrea',
  add_zona_descripcion: 'Ompli el formulari i afegeix la zona al mapa.\nGràcies. La resta d\'usuaris gaudiran de la teva aportació.',
  nueva_zona_nombre: 'Nom',
  nueva_zona_descripcion: 'Descripció',
  nueva_zona_ciudad: 'Ciutat',
  nueva_zona_pais: 'País',
  nueva_zona_zona_banyo: 'Podem trobar àrea de bany?',
  nueva_zona_bar: 'Hi ha algun bar o restaurant?',
  nueva_zona_zona_infantil: 'Té àrea infantil?',
  nueva_zona_aseos: 'Quants banys té?',
  nueva_zona_mesas: 'Quantes taules hi han?',
  nueva_zona_fuentes: 'Quantes fonts d\'aigua hi han?',
  nueva_zona_barbacoa: 'Hi ha àrea de barbacoes?',
  nueva_zona_tipo_suelo: 'Quin tipus de sól hi ha en la seva majoria?',
  nueva_zona_url_imagen: 'Afegeix el link d\'una imatge',
  nueva_zona_add_btn: "Afegeix l'àrea",
  si: "Si",
  no: "No",
  cesped: "herba",
  tierra: "terra",
  piedras: "pedres",
  arena: "arena",
  asfalto: "asfalt",
  nueva_zona_error_titulo: "Atenció",
  nueva_zona_error_nombre: "Introdueix un nom",
  nueva_zona_error_ciudad: "Introdueix una ciutat",
  nueva_zona_error_país: "Introdueix un país",
  nueva_zona_error_aseos: "Introdueix un nombre correcte de banys",
  nueva_zona_error_fuentes: "Introdueix un nombre correcte de fonts",
  nueva_zona_error_mesas: "Introdueix un nombre correcte de taules",
  nueva_zona_creada: "S'ha creat el àrea correctament 👍🏽",
  info_zona_error_descripcion: "Deixa clar el error que descrius i intenta aportar una sol.lució.\nSi el error es la posició, la quantitat de taules, ..., envians la dada correcta.\nMoltes gràcies.",
  info_zona_error_titulo: "Comunicar un error",
  info_zona_error_boton: "Envia",
  info_zona_error_placeholder: "Escriu aquí la descripció del error",
  info_zona_error_enviado: "S'ha enviat correctament.Gràcies",
  info_zona_error_error: "Si us plau, posa una descripció per a el error.",
  bienvenida_texto: "Si coneixes algun àrea que no veus al mapa, només has de mantindre pulsat sobre el punt del mapa on vols afegir la noca zona i s'obrirà un formulari per a posar les dades. Quan els envies es mostrarà la nova àrea al mapa.\n\n" +
    "En el detall d'un àrea, pots fer click sobre el mapa per a obrir google maps amb les indicacions per a arribar al àrea o al megafon per a reportar si existeix algun error a àrea mostrada.\n\n" +
    "Amb aquest app podràs localitzar les àrees de picnic que tinguis al teu voltant.\n" +
    "També ports ajudar a afegir-ne més i que tots pugam gaudir de totes les àrees de picnic.",
  bienvenida_cerrar: "Tancar",
  bienvenida_no_mostrar: "No tornar a mostrar",
  change_detail_image_descripcion: "Escribe la URL de la imagen que quieras enviar",
  change_detail_image_boton: "Enviar url",
  change_detail_imageplaceholder: "Escribe aquí la Url",
  change_detail_image_titulo: "Imatge Rebuda",
  change_detail_image_enviado: "S'ha afegit la imatge de la zona. Gràcies.",
  change_detail_image_error_titulo: "Atención",
  change_detail_image_error: "Por favor, introduce la url de la imagen.",
  change_detail_image_foto: "Envia una nova foto",
  change_detail_image_foto_error: "Ha hagut un error al agafar la foto.\nRevisa els permisos de l'app.",
  select_language: "Sel.leciona el llenguatge",
  btn_ok: "OK",
  title_detalle: "Detall",
  translate_to: "Traduïr al Català",
  share_title: "Comparteix el àrea",
  share_text: "Mira aquest àrea de picnic",
  share_thanks: "Gràcies per compartir el àrea",
  share_copied_to_clipboard: "S'ha copiat la url al porta-retalls",
  error_location_denied: "Si vols utilitzar la ubicació has d'activar-ho als paràmetres",
  error_location: "Error al localitzar al usuari"
};
export default ca;